import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Confetti from "react-confetti";
import api from "@/lib/api";
import { TRIBES } from "@/lib/tribes";
import { useOverride } from "@/context/ContentContext";
import { Sparkles } from "lucide-react";

export default function Graduation() {
  const { childId } = useParams();
  const [child, setChild] = useState(null);
  useEffect(() => { api.get(`/children/${childId}`).then((r) => setChild(r.data)); }, [childId]);
  const tribeKey = child?.tribe;
  const gradName = useOverride("tribe", tribeKey || "", "graduation_name", "");
  const gradDesc = useOverride("tribe", tribeKey || "", "graduation_description", "");
  const manifesto = useOverride("tribe", tribeKey || "", "manifesto", "");
  if (!child) return <div className="min-h-screen shell-bg p-8">Loading…</div>;
  const tribe = TRIBES[child.tribe] || TRIBES.neutral;
  const finalGradName = gradName || tribe.graduation_name;
  const finalGradDesc = gradDesc || tribe.graduation_description;
  const finalManifesto = manifesto || tribe.manifesto;

  return (
    <div className={`min-h-screen tribe-${child.tribe || "neutral"} relative overflow-hidden`}>
      <Confetti colors={["#FF3CB4", "#C9A96E", "#E8D5B0", "#8B5E7A"]} numberOfPieces={220} recycle={false} />
      <div className="max-w-2xl mx-auto px-6 py-20 text-center relative z-10">
        <Sparkles size={40} className="mx-auto mb-4" style={{ color: "#FF3CB4" }} />
        {(child.is_self || child.tribe !== "neutral") && (
          <div className="text-xs uppercase tracking-[0.3em] font-bold" style={{ color: tribe.accent }}>{child.is_self ? "Your journey" : tribe.name}</div>
        )}
        <h1 className="font-display text-4xl md:text-6xl font-bold mt-4" style={{ color: tribe.ink }}>Welcome to the</h1>
        <h2 className="font-display text-4xl md:text-6xl font-bold" style={{ color: tribe.accent }}>{finalGradName}</h2>
        <div className="mt-8 font-display text-3xl" style={{ color: tribe.ink }}>{child.name}</div>
        {finalGradDesc && (
          <p className="mt-4 text-base md:text-lg opacity-80 max-w-lg mx-auto" style={{ color: tribe.ink }}>{finalGradDesc}</p>
        )}
        <p className="mt-6 text-lg opacity-80 italic" style={{ color: tribe.ink }}>You breathed. You practiced. You grew.</p>
        <p className="mt-2 text-sm opacity-70" style={{ color: tribe.ink }}>Twelve sessions. Countless quiet transformations.</p>
        {finalManifesto && (
          <p className="mt-10 leading-relaxed whitespace-pre-line" style={{ color: tribe.ink }}>"{finalManifesto}"</p>
        )}
        <Link to={`/child/${childId}`} data-testid="graduation-back" className="mt-10 inline-flex px-6 py-3 rounded-full font-semibold" style={{ background: tribe.accent, color: "#1E1E2E" }}>
          Return to journey
        </Link>
      </div>
    </div>
  );
}
